const formatNumberWithZero = {
  install(Vue) {
      Vue.filter('formatNumberWithZero', (value) => {
          if(value <= 9){
              value= "0" + value
              return value
          }
          else {
              return value
          }
      });
  },
};

export default formatNumberWithZero